import LabServiceModel from "@/models/LabServiceModel";

export default class InstrumentJigModel extends LabServiceModel {
  modelName() {
    return 'instrument-jig';
  }
  defaults() {
    return {
      id: null,
      instrument_id: null,
      jig_id: null,
      sample_type_id: null,
      instrument: null,
      jig: null,
      sample_type: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      instrument_id: (val) => (this.nullStringMutator(val)),
      jig_id: (val) => (this.nullStringMutator(val)),
      sample_type_id: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String
    }
  }
  validation() {
    return {}
  }
}
